import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Switch from "react-switch"
import {
  approveGstStatus,
  blockUser,
  deleteCategory,
  disapproveGstStatus,
  getEvents,
  getUser,
  unblockUser,
  updateGstStatus,
} from "services/ApiService"
import TableContainer from "../../components/Common/TableContainer"
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { toast, ToastContainer } from "react-toastify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLock, faUnlock } from "@fortawesome/free-solid-svg-icons"
import Loader from "components/Common/Loader"
import EventDataTable from "components/Common/EventDataTable"
import { base_url } from "utils/APIUrls"
// import Swal from "sweetalert2"
// import "sweetalert2/dist/sweetalert2.min.css"

function Event() {
  const [data, setData] = useState([])
  const [switch1, setswitch1] = useState(true)

  const [isLoading, setIsLoading] = useState(true)

  const fetchData = () => {
    getEvents()
      .then(res => {
        setData(res.data)
        setIsLoading(false)
      })
      .catch(error => {
        toast.error(error)
        toast.error("Failed to fetch user data")
      })
  }

  useEffect(() => {
    fetchData()
  }, [])

  console.log("data", data)

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        No
      </div>
    )
  }

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Yes
      </div>
    )
  }

  //meta title
  document.title = "Events | Telepathic Dashboard "

  return (
    <div className="page-content">
      <Breadcrumbs title="Dashboard" breadcrumbItem="Events" />

      <ToastContainer />
      {/* <div className="">
        <h4 className="mb-1">Fictitious Users</h4>
        <Switch
          uncheckedIcon={<Offsymbol />}
          checkedIcon={<OnSymbol />}
          className="me-1 mb-sm-8 mb-2"
          onColor="#626ed4"
          onChange={() => {
            setswitch1(!switch1)
          }}
          checked={switch1}
        />
      </div> */}
      <EventDataTable
        apiURL={`${base_url}/admin/v1/user/get-events`}
        idName="events"
      />
    </div>
  )
}

Event.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Event
